module.exports = __webpack_public_path__ + "static/media/03_game_play.9a083f78.gif";